import { z } from 'zod'

export const questionObject = z.object({
  id: z.string().nonempty().describe('ID'),
  title: z.string().describe('Título').nullish(),
  questionnaireId: z.string().describe('ID do questionário').nullish(),
  observation: z.string().describe('Observação').nullish(),
  type: z.string().describe('Tipo').nullish(),
  required: z.boolean().describe('Obrigatório').nullish(),
  parentQuestionId: z.number().describe('ID da pergunta pai').nullish(),
  ordinalPosition: z.number().describe('Posição ordinal').nullish(),
})
